import resume from '../assets/pdf/Vishnu-Ghosh-Resume.pdf'
import profileImg from '../assets/png/profileImg.png'

export const headerData = {
    name: 'Vishnu Ghosh',
    title: "Software Engineer",
    desciption:"I am working as a Java Developer in Infinite Computer Solutions. I did my Master's in Data Science from the University at Buffalo, New York. I have 5+ years of experience working as a Software Developer, working in Java and FrontEnd Technologies like ReactJS & React Native. My coursework included Machine Learning, Reinforcement Learning, Probability Theory, Database Modeling, Python",
    image: profileImg,
    resumePdf: resume
}
